<template>
    <div :style="{'height': step && step.backgroundImage ? '100%' : ''}">
        <div v-if="apiFailed" class="app-error-info">
            <img src="../assets/images/icon_server_down.svg" />
            <div>
                Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.
            </div>
        </div>
        <div
            v-if="str"
            v-show="initialized"
            class="app-container"
            :style="[{'backgroundImage': step && step.backgroundImage ? 'url(' + step.backgroundImage + ')' : '', 'background-color': config.backgroundImage ? 'transparent' : config.backgroundColor, 'color': config.textColor, 'height': config.adjustContent ? '100%' : ''}, config.screenStyles, step && step.screenContainerStyles ? step.screenContainerStyles : '']"
            :class="[config.font === 'montserrat' ? 'app-container-font-montserrat' : '', step && step.backgroundImage ? 'app-container-step-background' : '', step && step.footerMessage ? 'app-container-step-bottom' : '']"
        >
            <div class="app-content">
                <div
                    v-if="step && step.logo"
                    class="app-image"
                >
                    <img
                        :src="step.logo"
                        :style="{width: step.logoSize}"
                    />
                </div>
                <div
                    v-if="step && step.title"
                    class="app-title text-bold"
                    v-html="step.title"
                    :style="config.titleStyles"
                ></div>
                <div
                    v-if="step && step.subtitle"
                    class="app-subtitle text-bold"
                    v-html="step.subtitle"
                    :style="config.subtitleStyles"
                ></div>
                <div
                    v-if="step && step.image"
                    class="app-image"
                >
                    <img
                        :src="step.image"
                        :style="{width: step.imageSize}"
                    />
                </div>
                <div
                    v-if="step && step.info"
                    class="app-info"
                    v-html="step.info"
                    :style="[config.infoStyles, step.infoStyles]"
                ></div>
                <div
                    v-if="step && step.footerMessage"
                    class="app-footer-message"
                    v-html="step.footerMessage"
                    :style="[config.footerMessageStyles, step.footerMessageStyles]"
                ></div>
                <div
                    v-if="step && openedByApp"
                    class="app-footer"
                    :class="config.buttonsStyles"
                >
                    <v-btn
                        @click="confirm()"
                        class="app-button-next"
                    >
                        {{ step.buttonText ? (str[step.buttonText] ? str[step.buttonText] : step.buttonText) : str['confirm'] }}
                    </v-btn>
                </div>
                <div v-if="step.app" class="app-app-links">
                    <v-btn v-if="step.app.android" @click="openLinkUrl(step.app.android)" class="app-button-next">
                        ANDROID
                    </v-btn>
                    <v-btn v-if="step.app.ios" @click="openLinkUrl(step.app.ios)" class="app-button-next">
                        IOS
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Api from '../services/Api'
    import Utils from '../services/Utils'

    export default {
        data() {
            return {
                str: null,
                openedByApp: window.openedByApp,
                initialized: false,
                apiFailed: false,
                config: {},
                ptId: window.ptId,
                step: null
            }
        },
        beforeMount: function () {
            this.getStrings()
        },
        methods: {
            getStrings: function () {
                const self = this
                this.apiFailed = false
                this.$isLoading(true)
                Api.getStrings(function (response) {
                    if (response.success) {
                        window.strings = response.data
                        self.str = response.data
                        self.main()
                    } else {
                        self.$isLoading(false)
                        self.apiFailed = true
                    }
                })
            },
            main: function () {
                const self = this
                Utils.refreshAppUrl()
                Api.getRegisterConfig(function (response) {
                    self.$isLoading(false)
                    if (response.success) {
                        self.refreshData(response.data)
                    } else {
                        self.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            refreshData: function (config) {
                const self = this
                this.config = config
                if (!this.openedByApp && this.config.externalBackgroundColor) {
                    this.config.backgroundColor = this.config.externalBackgroundColor
                }
                Utils.setConfigStrings(this.config)
                this.step = this.config.steps.find(function (item) {
                    return item.id === 'success'
                })
                Utils.refreshAppUrl(this.config)
                Utils.refreshStyles(this.config, function () {
                    self.initialized = true
                })
            },
            confirm: function () {
                if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        event: 'close'
                    }))
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        event: 'success-close'
                    }))
                }
            },
            openLinkUrl: function (url) {
                if (window.appReceiveLink && document.getElementById('link-view')) {
                    document.getElementById('link-view').setAttribute('data', url)
                    document.getElementById('link-view').click()
                } else {
                    window.open(url)
                }
            },
        },
    }
</script>